import React from 'react';
import './TestimonialCard.scss';

export default function TestimonialCard({
  img,
  message,
  name,
  position,
  businessName
}) {
  return (
    <div className="testimonial-card">
      <p className="testimonial-card__message">{message}</p>
      <div className="testimonial-card__underline" />
      <div className="testimonial-card__footer">
        <div
          className="testimonial-card__avatar"
          style={{ backgroundImage: `url(${img})` }}
        />
        <div className="testimonial-card__info">
          <h6 className="testimonial-card__name">{name}</h6>
          <p className="testimonial-card__position">{position}</p>
          <p className="testimonial-card__business">{businessName}</p>
        </div>
      </div>
    </div>
  );
}
